"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIGGER_SUGGEST = void 0;
exports.TRIGGER_SUGGEST = {
    id: 'editor.action.triggerSuggest',
    title: '',
};
//# sourceMappingURL=commands.js.map